'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _TheScoreArticleSponsor = require('./TheScoreArticleSponsor.css');

var _TheScoreArticleSponsor2 = _interopRequireDefault(_TheScoreArticleSponsor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TheScoreArticleSponsor = function TheScoreArticleSponsor(props) {
  return _react2.default.createElement(
    'div',
    {
      className: 'jsx-' + _TheScoreArticleSponsor2.default.__scopedHash + ' ' + 'sponsor'
    },
    _react2.default.createElement(
      'span',
      {
        className: 'jsx-' + _TheScoreArticleSponsor2.default.__scopedHash + ' ' + 'text'
      },
      props.sponsor.text
    ),
    _react2.default.createElement('img', {
      alt: '',

      src: props.sponsor.logo.h48,
      className: 'jsx-' + _TheScoreArticleSponsor2.default.__scopedHash + ' ' + 'logo'
    }),
    _react2.default.createElement(_style2.default, {
      styleId: _TheScoreArticleSponsor2.default.__scopedHash,
      css: _TheScoreArticleSponsor2.default.__scoped
    })
  );
};

TheScoreArticleSponsor.propTypes = {
  sponsor: _propTypes2.default.shape({
    id: _propTypes2.default.number.isRequired,
    text: _propTypes2.default.string.isRequired,
    logo: _propTypes2.default.object.isRequired, // eslint-disable-line react/forbid-prop-types
    region: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.default = TheScoreArticleSponsor;